<template>
  <div>
    <v-dialog v-model="hideShow" width="860" persistent scrollable content-class="class-create-dialog" aria-label="开班排课">
      <v-card class="class-create-card">
        <v-card-title class="class-create-header">
          <span class="class-create-symbol"><v-icon color="#d9363e" size="26">mdi-calendar-plus</v-icon></span>
          <div><h2>开班排课</h2><p>设置班级与授课安排，让每一节课井然有序</p></div>
          <v-spacer />
          <v-btn icon aria-label="关闭开班排课" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="class-create-body">
          <section class="class-create-section" aria-labelledby="class-create-basic">
            <div class="class-create-section-heading"><h3 id="class-create-basic">班级信息</h3><span><b>*</b> 为必填项</span></div>
            <v-radio-group label="班级类型" v-model="add.class.classType" row hide-details class="class-create-type">
              <v-radio value="1" color="#d9363e"><template v-slot:label><span class="class-create-type-label"><strong>一对一</strong><small>为单个学员开班</small></span></template></v-radio>
              <v-radio value="2" color="#d9363e"><template v-slot:label><span class="class-create-type-label"><strong>班课</strong><small>设置班级人数</small></span></template></v-radio>
            </v-radio-group>
            <v-row>
              <v-col v-if="add.class.classType=='1'" cols="12" sm="6"><div class="class-create-option"><v-autocomplete :items="selectStudentList" v-model="add.selectedStudent" item-text="studentName" item-value="id" no-data-text="暂无学员" label="学员 *" return-object dense outlined hide-details color="#d9363e" @change="studentNameChanged" /><v-btn text class="class-create-option-add" @click="add.showStudentCreate=true"><v-icon small>mdi-plus</v-icon>新增学员</v-btn></div></v-col>
              <v-col v-if="add.class.classType=='2'" cols="12" sm="6"><v-text-field label="满班人数 *" type="number" v-model="add.class.maxQty" suffix="人" dense outlined hide-details color="#d9363e" /></v-col>
              <v-col cols="12" sm="6"><v-text-field label="班级名称 *" v-model="add.class.className" dense outlined hide-details color="#d9363e" /></v-col>
              <v-col cols="12" sm="6"><div class="class-create-option"><v-select :items="selectCourseList" v-model="add.class.courseId" item-text="courseName" item-value="id" label="课程 *" dense outlined hide-details color="#d9363e" /><v-btn text class="class-create-option-add" @click="add.showCourseCreate=true"><v-icon small>mdi-plus</v-icon>新增课程</v-btn></div></v-col>
              <v-col cols="12" sm="6"><div class="class-create-option"><v-select :items="selectRoomList" v-model="add.class.roomId" item-text="roomName" item-value="id" label="教室 *" dense outlined hide-details color="#d9363e" /><v-btn text class="class-create-option-add" @click="willShowRoomCreate"><v-icon small>mdi-plus</v-icon>新增教室</v-btn></div></v-col>
              <v-col cols="12" sm="6"><div class="class-create-option"><v-select :items="selectTeacherList" v-model="add.class.teacherId" item-text="trueName" item-value="id" label="主课老师 *" dense outlined hide-details color="#d9363e" /><v-btn text class="class-create-option-add" @click="add.showTeacherCreate=true"><v-icon small>mdi-plus</v-icon>新增老师</v-btn></div></v-col>
              <v-col cols="12" sm="6"><div class="class-create-assistants"><v-select :items="selectTeacherList" v-model="add.class.secondTeacherId" item-text="trueName" item-value="id" label="助教老师一（选填）" dense outlined clearable hide-details color="#d9363e" /><v-select :items="selectTeacherList" v-model="add.class.thirdTeacherId" item-text="trueName" item-value="id" label="助教老师二（选填）" dense outlined clearable hide-details color="#d9363e" /></div></v-col>
            </v-row>
          </section>
          <div class="class-create-schedule-mode">
            <div><h3>排课设置</h3><p>{{add.class.onlyCreateClass === '1' ? '先创建班级，后续再安排上课时间' : '按下方规则安排班级的上课时间'}}</p></div>
            <v-checkbox v-model="add.class.onlyCreateClass" label="只开班不排课" color="#d9363e" value="1" hide-details class="ma-0 pa-0" />
          </div>
          <template v-if="add.class.onlyCreateClass!=='1'">
            <section class="class-create-section" aria-labelledby="class-create-lessons">
              <div class="class-create-section-heading"><h3 id="class-create-lessons">开课与课次</h3></div>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-menu ref="menu5" v-model="menu5" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }"><v-text-field v-model="add.class.beginDate" label="开课日期 *" prepend-inner-icon="mdi-calendar-blank-outline" readonly v-bind="attrs" v-on="on" dense clearable outlined hide-details color="#d9363e" /></template>
                    <v-date-picker v-model="add.class.beginDate" @input="menu5=false" no-title scrollable locale="zh-cn" />
                  </v-menu>
                </v-col>
                <v-col cols="6" sm="3"><v-text-field label="总课次数 *" type="number" v-model="add.class.lessonCount" dense outlined hide-details color="#d9363e" /></v-col>
                <v-col cols="6" sm="3"><v-text-field label="每节课扣课时数 *" type="number" v-model="add.class.reduceQty" dense outlined hide-details color="#d9363e" /></v-col>
              </v-row>
            </section>
            <section class="class-create-section class-create-plans-section" aria-labelledby="class-create-plans">
              <div class="class-create-section-heading"><h3 id="class-create-plans">上课时间安排</h3><v-btn text small class="class-create-add-plan" @click="addTimePlan"><v-icon left size="17">mdi-plus</v-icon>添加排课时间</v-btn></div>
              <p class="class-create-plan-hint">选择上课时间后，根据时长自动计算下课时间。</p>
              <div v-for="(item,index) in add.class.timePlanList" :key="item.key" class="class-create-plan">
                <div class="class-create-plan-heading"><span>排课时间 {{index + 1}}</span><v-btn icon small :aria-label="'删除排课时间 ' + (index + 1)" @click="add.class.timePlanList.splice(index, 1)"><v-icon size="19">mdi-trash-can-outline</v-icon></v-btn></div>
                <div class="class-create-plan-fields">
                  <v-select v-model="item.weekAt" :items="global.weekList" label="周几上课 *" item-text="weekName" item-value="week" outlined dense hide-details color="#d9363e" />
                  <v-menu v-model="item.menuFrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on, attrs }"><v-text-field v-model="item.timeFrom" label="上课时间 *" prepend-inner-icon="mdi-clock-time-four-outline" dense outlined hide-details readonly v-bind="attrs" v-on="on" color="#d9363e" /></template>
                    <v-time-picker v-if="item.menuFrom" v-model="item.timeFrom" full-width format="24hr" @click:minute="saveItemTimeFrom(item.key,item.timeFrom)" />
                  </v-menu>
                  <v-text-field label="时长（分钟）" type="number" v-model="item.timeMinutes" dense outlined hide-details color="#d9363e" @keyup="calItemTimeTo(item)" />
                  <v-menu v-model="item.menuTo" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on, attrs }"><v-text-field v-model="item.timeTo" label="下课时间 *" prepend-inner-icon="mdi-clock-time-four-outline" dense outlined hide-details readonly v-bind="attrs" v-on="on" color="#d9363e" /></template>
                    <v-time-picker v-if="item.menuTo" v-model="item.timeTo" full-width format="24hr" @click:minute="saveItemTimeTo(item.key,item.timeTo)" />
                  </v-menu>
                </div>
              </div>
              <div v-if="!add.class.timePlanList.length" class="class-create-no-plans">暂无排课时间，请点击“添加排课时间”设置。</div>
            </section>
          </template>
        </v-card-text>
        <v-card-actions class="class-create-footer"><span>{{add.class.onlyCreateClass === '1' ? '仅创建班级' : '创建班级并安排课程'}}</span><v-spacer /><v-btn outlined class="class-create-cancel" @click="cancel">取消</v-btn><v-btn depressed color="#d9363e" dark @click="submitAddClass" :loading="add.submitLoadding">确认开班</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
    <roomCreate :show="add.showRoomCreate" @cancel="add.showRoomCreate=false" @success="roomCreated" />
    <courseCreate :show="add.showCourseCreate" @cancel="add.showCourseCreate=false" @success="courseCreated" />
    <createTeacher :show="add.showTeacherCreate" @cancel="add.showTeacherCreate=false" @success="teacherCreated" />
    <createStudent :show="add.showStudentCreate" @cancel="add.showStudentCreate=false" @success="studentCreated" />
  </div>
</template>

<script>
	import utils from "../config/utils"
	import global from "../config/global"
	import roomCreate from "./room_create.vue"
	import courseCreate from "./course_create.vue"
	import createTeacher from "./create_teacher.vue"
	import createStudent from "./create_student.vue"
	export default {
		name:"create-class",
		components:{roomCreate,courseCreate,createTeacher,createStudent},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
		},
		watch:{
			show(newVal,oldVal){
				console.log("create class show=",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					
					// 清空add历史数据
					this.add.class.className = "";
					this.add.class.courseId = "";
					this.add.class.teacherId = "";
					this.add.class.roomId = "";
					this.add.class.beginDate = "";
					this.add.class.classType ="1";
					this.add.class.maxQty = "10";
					this.add.class.lessonCount = "16";
					this.add.class.studentId = "";
					this.add.class.reduceQty = "1";
					this.add.class.onlyCreateClass = "0"; 
					this.add.class.secondTeacherId ="";
					this.add.class.thirdTeacherId ="";
					
					// 添加一条时间记录
					this.add.class.timePlanList = [];
					this.addTimePlan();
					
				}
			},
		},
		data(){
			this.submitAddClass = utils.throttle(this.submitAddClass,500)
			return {
				global:global,
				imgPrev:global.config.imgPre,
				shopId:"",
				itemIndex:0,
				menu5: false, // 开课日期menu
				selectCourseList: [], //选择课程数据源
				selectTeacherList: [], //选择老师数据源
				selectRoomList: [], 	//选择教室数据源
				selectStudentList:[],	//选择学员数据源
				add: {
					dialog: false,
					submitLoadding:false,
					class: {
						classType:"1",
						className: "",
						courseId: "",
						maxQty: "10",
						teacherId: "",
						roomId: "",
						beginDate:"",
						lessonCount:"16",
						reduceQty:"1",
						timePlanList:[], //上课时间安排
						studentId:"",// 1对1学员ID
						onlyCreateClass:"0" ,// 只开班 1=只开班 
						secondTeacherId:"",
						thirdTeacherId:"",
					},
					selectedStudent:null,   //一对一选中的学员
					showRoomCreate:false,   //创建教室组件的显示与否
					showCourseCreate:false, //创建课程组件的显示与否
					showTeacherCreate:false,//创建教师组件的显示与否
					showStudentCreate:false,//创建学员组件的显示与否
					
				},
				hideShow:this.show
			}
		},
		mounted() {
			console.log("create-class mounted");
			
			this.shopId = utils.getCurrentShopId(); 
			
			this.getCourseListForSelect();
			this.getTeacherListForSelect();
			this.getClassroomListForSelect();
			this.getStudentListForSelect();
			
			// 添加一条时间记录
			this.add.class.timePlanList = [];
			this.addTimePlan();
		},
		methods:{
			//选择学员自动设置班级名称
			studentNameChanged(){
				console.log("studentname changed");
				if(this.add.selectedStudent){
					this.add.class.studentId = this.add.selectedStudent.id;
					this.add.class.className = this.add.selectedStudent.studentName +"一对一";
				}else{
					this.add.class.studentId = "";
					this.add.class.className = "";
				}
			},
			calItemTimeTo(item){
				// 选择开始时间 自动计算 结束时间
				console.log("timeFrom:",item.timeFrom);
				console.log("timeMinutes:",item.timeMinutes);
				
				// 必须有开始时间和时长
				if (!item.timeFrom || !item.timeMinutes){
					item.timeTo = "";
					console.log("no timeFrom or minutes");
					return
				}
				
				// 开始时间分割
				let arr = item.timeFrom.split(":");
				if (!arr || arr.length != 2){
					console.log("timeFrom invalid");
					return
				}
				// 构建一个日期 加上分钟数
				var sdate1 = new Date(2027,1,1,parseInt(arr[0]),parseInt(arr[1]),1);
				sdate1.setMinutes (sdate1.getMinutes () + parseInt(item.timeMinutes));
				
				// 新的时间和分钟
				let newHour = sdate1.getHours();
				let newMinutes = sdate1.getMinutes();
				
				// 左侧补齐2位
				const  hh = (Array(2).join(0) + newHour).slice(-2);
				const  mm = (Array(2).join(0) + newMinutes).slice(-2);
				
				var timeTo = hh+":"+mm;
				
				item.timeTo = timeTo;
				console.log("item.timeTo",item.timeTo);
				
			},
			cancel(){
				this.$emit("cancel","");
			},
			addTimePlan(){
				// 增加一条排课计划
				this.itemIndex++;
				let plan = {key:this.itemIndex,menuFrom:false,menuTo:false,weekAt:"",timeFrom:"",timeTo:"",timeMinutes:"45"}
				this.add.class.timePlanList.push(plan);
			},
			saveItemTimeFrom(key,v){
				// 保存开始时间
				this.add.class.timePlanList.forEach((item,index)=>{
					if(item.key === key){
						item.timeFrom = v;
						item.menuFrom = false;
						// 计算结束时间
						this.calItemTimeTo(item)
					}
				});
			},
			saveItemTimeTo(key,v){
				// 保存结束时间
				this.add.class.timePlanList.forEach((item,index)=>{
					if(item.key === key){
						item.timeTo = v;
						item.menuTo = false;
					}
				});
			},
			willShowRoomCreate(){
				// 点击了创建教室
				this.add.showRoomCreate = true;
			},
			roomCreated(){
				// 教室创建成功
				this.add.showRoomCreate = false;
				this.getClassroomListForSelect();
			},
			courseCreated(){
				// 课程创建成功
				this.add.showCourseCreate = false;
				this.getCourseListForSelect();
				
			},
			teacherCreated(){
				//老师创建成功
				this.add.showTeacherCreate = false;
				this.getTeacherListForSelect();
			},
			studentCreated(){
				// 学员创建成功
				this.add.showStudentCreate = false;
				this.getStudentListForSelect();
			},
			
			submitAddClass() {
				// 班级类型
				const classType = this.add.class.classType;
				 
				if(!classType){
					this.$noty.error('请选择班级类型');
					return
				}
				// 只开班 1=只开班 
				const onlyCreateClass = this.add.class.onlyCreateClass;
				
				
				if (!this.add.class.className) {
					this.$noty.error('班级名称不能为空');
					return
				}
			
				if (!this.add.class.courseId) {
					this.$noty.error('课程不能为空');
					return
				}
				if(classType == '2'){
					// 班课
					if (!this.add.class.maxQty) {
						this.$noty.error('满班人数不能为空');
						return
					}
				}else if (classType=='1'){
					// 一对一
					if (!this.add.class.studentId) {
						this.$noty.error('学员不能为空');
						return
					}
				}
				
				if (!this.add.class.teacherId) {
					this.$noty.error('老师不能为空');
					return
				}
				
				if (!this.add.class.roomId) {
					this.$noty.error('教室不能为空');
					return
				}
				// 选择了助教一
				if (this.add.class.secondTeacherId){
					if (this.add.class.teacherId == this.add.class.secondTeacherId){
						this.$noty.error('助教老师一不能和主课老师相同');
						return
					}
				}
				// 选择了助教二
				if (this.add.class.thirdTeacherId){
					
					if (!this.add.class.secondTeacherId){
						this.$noty.error('请先设置助教老师一');
						return
					}
					
					if (this.add.class.teacherId == this.add.class.thirdTeacherId){
						this.$noty.error('助教老师不能和主课老师相同');
						return
					}
					
					if (this.add.class.secondTeacherId == this.add.class.thirdTeacherId){
						this.$noty.error('助教老师二不能和助教老师一相同');
						return
					}
					
				}
				
				// 不是只开班 还要排课
				if (this.add.class.onlyCreateClass !== "1"){
					
					if (!this.add.class.lessonCount) {
						this.$noty.error('班级课次不能为空');
						return
					}
					
					if (!this.add.class.reduceQty) {
						this.$noty.error('扣课时数不能为空');
						return
					}
					if (!this.add.class.beginDate) {
						this.$noty.error('开课日期不能为空');
						return
					}
					
					if(this.add.class.timePlanList.length == 0){
						this.$noty.error('缺少上课时间安排');
						return
					}
					
					// 检查时间数据是否合法
					this.add.class.timePlanList.forEach((item,index)=>{
						if (!item.weekAt){
							this.$noty.error('上课时间安排未选择周几上课');
							return
						}
						if (!item.timeFrom){
							this.$noty.error('上课时间安排未选择开始时间');
							return
						}
						if (!item.timeTo){
							this.$noty.error('上课时间安排未选择结束时间');
							return
						}
					})
				}
				

				// api
				const that = this;
				let url = `/edu/class/create`;
				let postData = {
					...this.add.class
				};
				postData.shopId = this.shopId;
				
				// 不是只开班 就是需要排课
				if(this.add.class.onlyCreateClass !== '1'){
					postData.onlyCreateClass = "0";
				}else{
					postData.lessonCount = "0";
				}
				
				console.log(postData);
			
				this.add.submitLoadding = true;
			
				this.axios.post(url, postData).catch(() => {
					that.add.submitLoadding = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.add.submitLoadding = false;
							that.$noty.success("添加成功");
							
							that.$emit("success","");
							return;
						} else {
							that.add.submitLoadding = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitLoadding = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			
			},
			getCourseListForSelect() {
				if (!this.shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/course/list/` + this.shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						let cList = response.data["data"] ? response.data["data"] : [];
						that.selectCourseList = cList.filter(item=>item.status == "1");
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getTeacherListForSelect() {
			
				if (!this.shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/teacher/list/` + this.shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getClassroomListForSelect() {
			
				if (!this.shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/classroom/list/` + this.shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectRoomList = response.data["data"] ? response.data["data"] : [];
						return
					}
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getStudentListForSelect() {
				
				// 获取校区学生列表
				if (!this.shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/student/list/` + this.shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectStudentList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			
		}
	}
	
</script>

<style scoped lang="scss" src="../assets/styles/class-create.scss"></style>
